import i18n from '../../Utils/i18n';
import {
  RegistrantsTableColumns,
  AttendeesTableColumns,
  SessionsTableVisibleColumns,
  VirtualEventsTableVisibleColumns,
  RecordingsTableVisibleColumns,
  RecordingSource,
  RecordingViewsVisibleColumns
} from '../../Utils/Constants';

export function getRegistrantsTableColumnOptions() {
  let menuItems = [];
  menuItems.push(
    {
      title: i18n.t('sessionDetails.registrationDateAndTime'),
      id: RegistrantsTableColumns.REGISTRATION_TIME
    },
    {
      title: i18n.t('sessionDetails.unsubscribed'),
      id: RegistrantsTableColumns.UNSUBSCRIBED
    },
    {
      title: i18n.t('sessionDetails.status'),
      id: RegistrantsTableColumns.STATUS
    },
    {
      title: i18n.t('sessionDetails.source'),
      id: RegistrantsTableColumns.SOURCE
    }
  );
  return menuItems;
}

export function getAttendeesTableColumnOptions() {
  let menuItems = [];
  menuItems.push(
    {
      title: i18n.t('sessionDetails.interestRating'),
      id: AttendeesTableColumns.INTEREST_RATING
    },
    {
      title: i18n.t('sessionDetails.timeInSession'),
      id: AttendeesTableColumns.TIME_IN_SESSION
    },
    {
      title: i18n.t('sessionDetails.certificateSentInFollowUpMail'),
      id: AttendeesTableColumns.CERTIFICATE_SENT
    },
    {
      title: i18n.t('sessionDetails.numberOfPollsAnswered'),
      id: AttendeesTableColumns.POLL_ANSWERED_COUNT
    },
    {
      title: i18n.t('sessionDetails.numberOfSurveyQuestionsAnswered'),
      id: AttendeesTableColumns.SURVEY_QUESTION_ANSWERED_COUNT
    },
    {
      title: i18n.t('sessionDetails.numberOfQuestionsAsked'),
      id: AttendeesTableColumns.QUESTION_COUNT
    }
  );
  return menuItems;
}

export function getSessionsTableColumnOptions() {
  let menuItems = [];
  menuItems.push(
    {
      title: i18n.t('tableHeaderColumns.day'),
      id: SessionsTableVisibleColumns.DAY
    },
    {
      title: i18n.t('tableHeaderColumns.date'),
      id: SessionsTableVisibleColumns.DATE
    },
    {
      title: i18n.t('tableHeaderColumns.startTime'),
      id: SessionsTableVisibleColumns.START_TIME
    },
    {
      title: i18n.t('tableHeaderColumns.registrants'),
      id: SessionsTableVisibleColumns.REGISTRANT_COUNT
    },
    {
      title: i18n.t('tableHeaderColumns.attendees'),
      id: SessionsTableVisibleColumns.ATTENDEE_COUNT
    },
    {
      title: i18n.t('tableHeaderColumns.attendanceRate'),
      id: SessionsTableVisibleColumns.ATTENDANCE_RATE
    }
  );
  return menuItems;
}

export function getRecordingsTableColumnOptions() {
  let menuItems = [];
  menuItems.push(
    {
      title: i18n.t('tableHeaderColumns.publishedDate'),
      id: RecordingsTableVisibleColumns.PUBLISHED_DATE
    },
    {
      title: i18n.t('tableHeaderColumns.views'),
      id: RecordingsTableVisibleColumns.VIEWS
    },
    {
      title: i18n.t('tableHeaderColumns.shares'),
      id: RecordingsTableVisibleColumns.SHARES
    },
    {
      title: i18n.t('tableHeaderColumns.length'),
      id: RecordingsTableVisibleColumns.LENGTH
    },
    {
      title: i18n.t('tableHeaderColumns.avgViewDuration'),
      id: RecordingsTableVisibleColumns.AVG_VIEW_DURATION
    },
    {
      title: i18n.t('tableHeaderColumns.source'),
      id: RecordingsTableVisibleColumns.SOURCE
    }
  );
  return menuItems;
}

export function getVirtualEventsTableColumnOptions() {
  let menuItems = [];
  menuItems.push(
    {
      title: i18n.t('tableHeaderColumns.name'),
      id: VirtualEventsTableVisibleColumns.NAME
    },
    {
      title: i18n.t('tableHeaderColumns.date'),
      id: VirtualEventsTableVisibleColumns.DATE
    },
    {
      title: i18n.t('tableHeaderColumns.startTime'),
      id: VirtualEventsTableVisibleColumns.START_TIME
    },
    {
      title: i18n.t('tableHeaderColumns.registrants'),
      id: VirtualEventsTableVisibleColumns.REGISTRANT_COUNT
    }
  );
  return menuItems;
}

export function getRecordingDetailsTableColumnOptions(recordingSource) {
  const defaultColumnTypes = [
    {
      title: i18n.t('recordingDetails.lastWatchedDate'),
      id: RecordingViewsVisibleColumns.LAST_WATCH_DATE
    },
    {
      title: i18n.t('recordingDetails.viewCount'),
      id: RecordingViewsVisibleColumns.VIEW_COUNT
    }
  ];

  const g2sColumnTypes = [
    {
      title: i18n.t('recordingDetails.avgPercentageViewed'),
      id: RecordingViewsVisibleColumns.AVG_PERC_VIEWED
    },
    {
      title: i18n.t('recordingDetails.viewDuration'),
      id: RecordingViewsVisibleColumns.VIEW_DURATION
    }
  ];

  const g2sEmbeddedColumnTypes = [
    {
      title: i18n.t('recordingDetails.parentUrl'),
      id: RecordingViewsVisibleColumns.SOURCE_EMBEDDED_LINK
    }
  ];

  const extraColumns =
    RecordingSource.G2S === recordingSource
      ? g2sColumnTypes
      : RecordingSource.G2S_EMBEDDED === recordingSource
      ? g2sEmbeddedColumnTypes
      : [];

  return [...defaultColumnTypes, ...extraColumns];
}



// WEBPACK FOOTER //
// ./src/Components/CheckedMenu/CheckedMenuItemsHelper.js